//
// Module for the AccountReview Edit view
//
rs.module("participant/account/accountreview/edit",

    ["common/select-helper"],

    function (selectHelper) {
        //
        // Initialize the module
        //
        function initialize(jsSelectors, internalCodeValue, shouldDefaultUser, esfUserId) {

            var form = $.js(jsSelectors.form);
            var auditModeSelect = form.js(jsSelectors.auditModeSelect);

            displayAppropriateAuditors();

            auditModeSelect.change(displayAppropriateAuditors);

            /**
            * Show or hide the appropriate auditors based on
            * selected code value
            */
            function displayAppropriateAuditors() {

                var internalSelected = auditModeSelect.val() === internalCodeValue.toString();

                form.js(jsSelectors.internalAuditRow).toggle(internalSelected);
                form.js(jsSelectors.externalAuditRow).toggle(!internalSelected);

                if (internalSelected && shouldDefaultUser) {
                    selectHelper.getHelper(form.js(jsSelectors.internalAuditSelect)).setValue(esfUserId);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);